export default __webpack_public_path__ + "static/media/overview.d4aca263.svg";